import {
	Manufacturer,
	UnitMesaureInterface,
} from '../../interfaces/Core.interface';
import { api } from '../slices/api';

// Define a service using a base URL and expected endpoints
export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		getUnitsOfMeasure: builder.query<UnitMesaureInterface[], void>({
			query: () => 'units-of-measure',
		}),
		getManufacturers: builder.query<Manufacturer[], void>({
			query: () => 'manufacturers',
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUnitsOfMeasureQuery, useGetManufacturersQuery } =
	extendedApiSlice;
